import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import CaseDocumentFileTag from "../CaseDocumentFileTag";
import ActionLink from "../CaseDocumentActionLink";

interface CaseDocumentFailedFileRowProps {
  file: { name: string; mime_type: string };
  title: string;
  reason: ReactNode;
  onReplace?: () => void;
  onRemove?: () => void;
}

const CaseDocumentFailedFileRow: FC<CaseDocumentFailedFileRowProps> = ({
  file,
  title,
  reason,
  onReplace,
  onRemove,
}) => (
  <Flex
    align="flex-start"
    gap={3}
    px="14px"
    py="11px"
    borderRadius="8px"
    border="1px solid"
    borderColor="brand.error/30"
    bg="score.lowBg/50"
  >
    <CaseDocumentFileTag file={file} muted />
    <Flex direction="column" gap="3px" flex={1} minW={0}>
      <Text truncate fontSize="14px" color="brand.modalHeaderText">
        {file.name}
      </Text>
      <Text fontSize="13px" fontWeight={FONT_WEIGHT.HEAVY} color="score.lowText">
        {title}
      </Text>
      <Text fontSize="13px" lineHeight={1.5} color="brand.textSecondary">
        {reason}
      </Text>
    </Flex>
    {(onReplace || onRemove) && (
      <Flex gap={4} flexShrink={0}>
        {onReplace && <ActionLink onClick={onReplace}>Replace</ActionLink>}
        {onRemove && (
          <ActionLink color="brand.textSecondary" onClick={onRemove}>
            Remove
          </ActionLink>
        )}
      </Flex>
    )}
  </Flex>
);

export default CaseDocumentFailedFileRow;
